import { ProfileStepsNav } from 'app/components/shared/ProfileStepsNav'
import { Base } from 'app/components/ui/Base'
import { Button } from 'app/components/ui/Button'
import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'
import React from 'react'
import styled from 'styled-components'

interface Props {
  onThanksCompleted?: () => void
}

export const RegistrationThanks: React.FC<Props> = ({ onThanksCompleted }) => {
  return (
    <>
      <Container>
        <ProfileStepsNav currentStep={'thank_you'}></ProfileStepsNav>
      </Container>
      <Base
        paddingTop={2}
        bgImage='https://res.cloudinary.com/estra/image/upload/v1612541057/estra20dev/area_fornitori/signup/thanks_bg.svg'
      >
        <RegistrationThanksContainer>
          <TextWrapper>
            <Text variant='s24' mb={3}>
              Ottime notizie! La parte più noiosa è finita e ora puoi andare a
              gestire le richieste dei preventivi che ti invieremo direttamente
              in questo sistema.{'\n'}Se avrai necessità di aggiornare qualche
              dato o scaricare il PDF della tua anagrafica, puoi trovare tutto
              nel tuo profilo in tutte le pagine in alto a destra.
            </Text>
          </TextWrapper>
          <Button size='lg' onClick={onThanksCompleted}>
            CHIUDI E TORNA ALLA PAGINA PRINCIPALE
          </Button>
        </RegistrationThanksContainer>
      </Base>
    </>
  )
}

const RegistrationThanksContainer = styled(Container)`
  text-align: center;
`

const TextWrapper = styled.div`
  max-width: 900px;

  margin-right: auto;
  margin-left: auto;
`
